<template>
  <v-card>
    <v-card-title>About Me</v-card-title>
    <v-card-text class="text-subtitle-2">
      I began my journey into computer science as a Data Scientist by studying with one of the professors in my university. 
      I was learning Machine Learning algorithms, data analysis methods, Python libraries and tools such as Pandas, Apache Spark etc.
      While continuing to study at university, I started to work in a small start-up company as a freelance developer. 
      My responsibilities included scraping data from various social media platforms, processing these data in our pipelines and developing a RESTful API. 
      When I graduated, I quit my freelance job and started to work in another start-up company as a Full Stack Data Scientist. 
      I was responsible for using indicators on machine learning models that are developed for stock market value prediction. I worked for a few months. 
      Then I moved to Istanbul to work in TUBITAK, one of the Turkish research company.
      I worked on big data projects and software development projects more than 2 years.
      Now, I am working at DeepInfo, network security company, as a software developer. I am responsible for developing a RESTful API with Django and FastAPI. 
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'AboutMe'
}
</script>

<style>

</style>